import { FieldValidity, ValidationResult } from "./SearchRequestTermValidations";
import { messages } from "./SearchUtils";

export function isSearchNameValid(name?: string): ValidationResult {
    if (!name || name.trim() === "") {
        return { status: FieldValidity.Missing, message: messages.enterSearchName };
    }
    return { status: FieldValidity.Valid };
}
